import React from 'react'
import { TableContainer, Grid, Table } from '@material-ui/core'
import { Head, Body } from './TableContents'

const GradeTable = ({ gradeLevelRows, gradeLevelRowInputChanged, percentError, translate }) => {
  // const classes = useStyles()
  return (
    <Grid item xs={12}>
      <TableContainer>
        <Table stickyHeader>
          <Head percentError={percentError} translate={translate} />
          <Body rowData={gradeLevelRows} rowInputChanged={gradeLevelRowInputChanged} />
        </Table>
      </TableContainer>
    </Grid>
  )
}

// const useStyles = makeStyles({
//   tableContainer: {
//     maxHeight: 400
//   }
// })

export default GradeTable
